import globals from "./globals";
import $ from "cash-dom";
import Masonry from "masonry-layout";

const component = (function () {
    /**
     * Initialize Contact Sheet instances
     */
    $(window).on("load", function () {
        if ($(".masonry-grid").length) {
            if (globals.debug) console.log("component-masonry initialized");

            $(".masonry-grid").each(function () {
                var container = $(this)[0];

                new Masonry(container, {
                    itemSelector: ".masonry-grid-cell",
                    transitionDuration: 0,
                });
            });
        }
    });
})();

export default component;
